import script from "./MaterialAssignmentInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialAssignmentInfo.vue?vue&type=script&setup=true&lang=js"

import "./MaterialAssignmentInfo.vue?vue&type=style&index=0&id=13e7767c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e7767c"]])

export default __exports__